const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/_dynamicLayout/c/$spaceSlug/_spaceLockGuard/sections/$sectionId/lessons/$lessonId.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
const lessonSearchSchema = z.object({
  message_id: z.coerce.number().optional().catch(undefined)
});
export const Route = createFileRoute("/_protected/_dynamicLayout/c/$spaceSlug/_spaceLockGuard/sections/$sectionId/lessons/$lessonId")({
  validateSearch: lessonSearchSchema,
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});